<ca-modal-container
    modalTitle="{{ 'MY_WORKSPACE.USER_PROFILE.EDIT_PROFILE_TITLE' | translate }}"
    description="{{ 'MY_WORKSPACE.USER_PROFILE.EDIT_PROFILE_DESCRIPTION' | translate }}"
    (dismiss)="dismiss('Canceled')"
    data-uit="user-profile-edit-popup"
>
    <form [formGroup]="formGroup" (ngSubmit)="submitProfile()">
        <div class="row my-2">
            <div class="col-12 col-sm-6">
                <div class="d-flex flex-column-reverse">
                    <input
                        class="form-control"
                        formControlName="title"
                        maxlength="10"
                        data-uit="user-profile-edit-field-title"
                        [ngClass]="formGroup.get('title')?.touched && formGroup.get('title')?.errors ? 'has-error' : ''"
                    />
                    <label>{{ 'GENERAL.TITLE' | translate }}</label>
                </div>
                <small *ngIf="formGroup.get('title')?.touched && formGroup.get('title')?.hasError('pattern')" class="invalid-feedback">
                    {{ 'GENERAL.INVALID_TITLE' | translate }}
                </small>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-sm-6">
                <div class="d-flex flex-column-reverse">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="First Name"
                        formControlName="firstName"
                        maxlength="20"
                        required
                        data-uit="user-profile-edit-field-firstname"
                        [ngClass]="formGroup.get('firstName')?.touched && formGroup.get('firstName')?.errors ? 'has-error' : ''"
                    />
                    <label>{{ 'MY_WORKSPACE.USER_PROFILE.FIRSTNAME' | translate }}<span class="red">*</span></label>
                </div>
                <small *ngIf="formGroup.get('firstName')?.touched && formGroup.get('firstName')?.hasError('required')" class="invalid-feedback">
                    {{ 'GENERAL.REQUIRED_FIELD' | translate }}
                </small>
                <small *ngIf="formGroup.get('firstName')?.touched && formGroup.get('firstName')?.hasError('pattern')" class="invalid-feedback">
                    {{ 'MY_WORKSPACE.USER_PROFILE.INVALID_FIRSTNAME' | translate }}
                </small>
            </div>
            <div class="col-12 col-sm-6">
                <div class="d-flex flex-column-reverse">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Last Name"
                        required
                        maxlength="20"
                        formControlName="lastName"
                        data-uit="user-profile-edit-field-lastname"
                        [ngClass]="formGroup.get('lastName')?.touched && formGroup.get('lastName')?.errors ? 'has-error' : ''"
                    />
                    <label>{{ 'MY_WORKSPACE.USER_PROFILE.LASTNAME' | translate }}<span class="red">*</span></label>
                </div>
                <small *ngIf="formGroup.get('lastName')?.touched && formGroup.get('lastName')?.hasError('required')" class="invalid-feedback">
                    {{ 'GENERAL.REQUIRED_FIELD' | translate }}
                </small>
                <small *ngIf="formGroup.get('lastName')?.touched && formGroup.get('lastName')?.hasError('pattern')" class="invalid-feedback">
                    {{ 'MY_WORKSPACE.USER_PROFILE.INVALID_LASTNAME' | translate }}
                </small>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-sm-6">
                <div class="d-flex flex-column-reverse">
                    <input
                        type="text"
                        class="form-control"
                        formControlName="organization"
                        maxlength="50"
                        data-uit="user-profile-edit-field-company"
                        [ngClass]="formGroup.get('organization')?.touched && formGroup.get('organization')?.errors ? 'has-error' : ''"
                    />
                    <label>{{ 'MY_WORKSPACE.USER_PROFILE.COMPANY' | translate }}</label>
                </div>
                <small *ngIf="formGroup.get('organization')?.touched && formGroup.get('organization')?.hasError('pattern')" class="invalid-feedback">
                    {{ 'MY_WORKSPACE.USER_PROFILE.INVALID_COMPANY' | translate }}
                </small>
            </div>
            <div class="col-12 col-sm-6">
                <div class="d-flex flex-column-reverse">
                    <input
                        type="text"
                        class="form-control"
                        formControlName="occupation"
                        maxlength="50"
                        data-uit="user-profile-edit-field-role"
                        [ngClass]="formGroup.get('occupation')?.touched && formGroup.get('occupation')?.errors ? 'has-error' : ''"
                    />
                    <label>{{ 'MY_WORKSPACE.USER_PROFILE.ROLE' | translate }}</label>
                </div>
                <small *ngIf="formGroup.get('occupation')?.touched && formGroup.get('occupation')?.hasError('pattern')" class="invalid-feedback">
                    {{ 'MY_WORKSPACE.USER_PROFILE.INVALID_ROLE' | translate }}
                </small>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6 d-flex flex-column-reverse">
                <input
                    type="text"
                    class="form-control"
                    formControlName="country"
                    maxlength="50"
                    [ngbTypeahead]="searchCountries"
                    [popupClass]="'custom-typeahead'"
                    data-uit="user-profile-edit-field-country"
                />
                <label>{{ 'MY_WORKSPACE.USER_PROFILE.COUNTRY' | translate }}</label>
            </div>
            <div class="col-12 col-sm-6">
                <div class="d-flex flex-column-reverse">
                    <input
                        type="text"
                        class="form-control"
                        formControlName="city"
                        maxlength="50"
                        data-uit="user-profile-edit-field-city"
                        [ngClass]="formGroup.get('city')?.touched && formGroup.get('city')?.errors ? 'has-error' : ''"
                    />
                    <label>{{ 'MY_WORKSPACE.USER_PROFILE.CITY' | translate }}</label>
                </div>
                <small *ngIf="formGroup.get('city')?.touched && formGroup.get('city')?.hasError('pattern')" class="invalid-feedback">
                    {{ 'MY_WORKSPACE.USER_PROFILE.INVALID_CITY' | translate }}
                </small>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-sm-6" *ngIf="myPrivacySettings">
                <div class="d-flex flex-column-reverse">
                    <input type="text" class="form-control" formControlName="email" data-uit="user-profile-edit-field-email" />
                    <label>{{ 'MY_WORKSPACE.USER_PROFILE.EMAIL' | translate }}</label>
                </div>
                <ca-input-checkbox class="d-block mt-1" formControlName="showEmail" data-uit="user-profile-edit-field-showemail">
                    {{ 'MY_WORKSPACE.USER_PROFILE.SHOW_EMAIL' | translate }}</ca-input-checkbox
                >
            </div>
            <div class="col-12 col-sm-6">
                <div class="d-flex flex-column-reverse">
                    <input
                        type="tel"
                        class="form-control"
                        formControlName="phoneNumber"
                        maxlength="50"
                        data-uit="user-profile-edit-field-phone"
                        [ngClass]="formGroup.get('phoneNumber')?.touched && formGroup.get('phoneNumber')?.errors ? 'has-error' : ''"
                    />
                    <label>{{ 'MY_WORKSPACE.USER_PROFILE.PHONE' | translate }}</label>
                </div>
                <small *ngIf="formGroup.get('phoneNumber')?.touched && formGroup.get('phoneNumber')?.hasError('pattern')" class="invalid-feedback">
                    {{ 'MY_WORKSPACE.USER_PROFILE.INVALID_PHONE' | translate }}
                </small>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-sm-6 d-flex flex-column-reverse">
                <input
                    type="text"
                    class="form-control"
                    formControlName="website"
                    maxlength="50"
                    data-uit="user-profile-edit-field-website"
                    [ngClass]="formGroup.get('website')?.touched && formGroup.get('website')?.errors ? 'has-error' : ''"
                />
                <label>{{ 'MY_WORKSPACE.USER_PROFILE.WEBSITE' | translate }}</label>
            </div>
            <small *ngIf="formGroup.get('website')?.touched && formGroup.get('website')?.hasError('pattern')" class="invalid-feedback">
                {{ 'MY_WORKSPACE.USER_PROFILE.WEBSITE_PATTERN_ERROR' | translate }}
            </small>
        </div>
        <div class="row mt-3 mb-5 form-group">
            <div class="col-12 d-flex flex-column-reverse h-100">
                <ca-quill-editor-wrapper
                    id="description"
                    formControlName="description"
                    [placeholder]="'MY_WORKSPACE.USER_PROFILE.PROVIDE_DESC' | translate"
                    data-uit="user-profile-edit-field-description"
                ></ca-quill-editor-wrapper>
                <label for="description">{{ 'MY_WORKSPACE.USER_PROFILE.PERSONAL_DESC' | translate }}</label>
            </div>
        </div>
        <div class="row">
            <div class="col-12 modal-buttons">
                <button type="submit" [disabled]="isSubmitting" caAutoFocus class="btn btn-primary mt-5" data-uit="save-and-close-modal">
                    {{ 'GENERAL.SAVE' | translate }}
                </button>
            </div>
        </div>
    </form>
</ca-modal-container>
